<template>
  <div class="lg:h-16 md:h-20 border-b border-t border-gray-300 flex sm:flex-row flex-col
    justify-between wrap items-left sm:items-center pl-8 md:pl-2 text-sm md:pr-2">
    <div class="flex pt-5 sm:pt-3 pb-3 items-center">
      <free-shipping-icon class="mr-2" />
      <div class="flex flex-col">
        <h2 class="font-bold">
        {{ $t('product.shipping') }}
        </h2>
        <h3 class="text-xs">
          {{$t('product.orders-over')}}
        </h3>
      </div>
    </div>
    <div class="flex flex-row items-center py-3">
      <secure-payments-icon class="mr-2" />
      <h2 class="font-bold">
        {{ $t('product.payment') }}
      </h2>
    </div>
    <div class="flex flex-row items-center py-3">
      <returns-icon class="mr-2" />
      <h2 class="font-bold">
        {{ $t('product.returns') }}
      </h2>
    </div>
  </div>
</template>

<script>
import FreeShippingIcon from '@/components/graphics/FreeShippingIcon.vue';
import SecurePaymentsIcon from '@/components/graphics/SecurePaymentsIcon.vue';
import ReturnsIcon from '@/components/graphics/ReturnsIcon.vue';

export default {
  components: {
    FreeShippingIcon,
    SecurePaymentsIcon,
    ReturnsIcon,
  },
};
</script>
